export const isArray = (data) => {
  return Array.isArray(data);
};

export const Date2String = (userDate, fulldate = false) => {
  var parts = userDate.split("-");
  // console.log(parts);
  let mydate = new Date(parts[0], parts[1] - 1, parts[2]);
  let thisdate__ = mydate.toDateString();
  let dateStringArray = thisdate__.split(" ");
  let chooseDate;
  if (fulldate === true) {
    chooseDate = dateStringArray[1] + " " + dateStringArray[2] + " " + dateStringArray[3];
  }
  else {
    chooseDate = dateStringArray[1] + " " + dateStringArray[2];

  }
  return chooseDate;
};
export const getprofile_details = () => new Promise((resolve, reject) => {

  // axios.get(`/fetch_user_profile/${id}`)
  //   .then(response => {
  //     resolve(response);
  //     //     if(response.data.status === true) {
  //     // let data=response.data.message;

  //     // resolve(data);
  //     //     }
  //     //     else {

  //     //       resolve [];
  //     //     }  
  //   })
  //   .catch(error => {
  //     resolve("Error");
  //     console.warn(`error ${error}`);
  //     // this.setState({
  //     //   allservices:[],
  //     //   loader_visible: false,
  //     //  })
  //   });
  const studentDetails = localStorage.getItem('studentInfo')
  // console.log(studentDetails, "loged in student ");
  const resp = JSON.parse(studentDetails);
  // const studentId = id[0].studentId;
  resolve(resp[0])
});